module.exports = __webpack_public_path__ + "img/simple_data.7d0e0208.png";